
(function() {

    var tinyMce = function() {
        return {
            restrict: 'A',
            scope:{
                requiredModel: "="
            },
            link: function(scope, element, attrs) {
                console.log('*** tinyMCE');
                console.log(element);
                console.log(element[0]);

                $(element[0]).tinymce({
                    // Location of TinyMCE script
                    script_url : WEBAPP_PATH+'/js/vendor/tiny_mce/tiny_mce.js',
                    // General options
                    theme : "advanced",
                    browser_spellcheck: true,
                    plugins : "fullscreen,preview,jqueryspellchecker,paste",
                    mode : "textareas",
                    // Theme options
                    theme_advanced_path : false,
                    theme_advanced_buttons1 : "bold,italic,underline,separator,strikethrough,justifyleft,justifycenter,justifyright,justifyfull,bullist,numlist,outdent,indent,formatselect,forecolor,backcolor",
                    theme_advanced_buttons2 : "cut,copy,paste,pastetext,separator,fontselect,fontsizeselect,separator,link,unlink,anchor,separator,fullscreen,separator,preview,jqueryspellchecker",
                    theme_advanced_buttons3 : "",
                    theme_advanced_toolbar_location : "top",
                    theme_advanced_toolbar_align : "left",
                    theme_advanced_statusbar_location : "bottom",
                    theme_advanced_resizing : false,
                    paste_text_sticky : true,
                    setup : function(ed) {
                        ed.onInit.add(function(ed) {
                            ed.pasteAsPlainText = true;
                        });

                        ed.onKeyUp.add(function(ed, e) {
                            if('requiredModel' in attrs){
                                if(ed.getContent().length > 0){
                                    scope.requiredModel = "true";
                                } else {
                                    scope.requiredModel = "";
                                }
                            }
                        });
                    },
                    // Spell checker configuration //
                    jqueryspellchecker_rpc_url : WEBAPP_PATH + "/spell/check",
                    // Drivier parameter is currently ignored.
                    jqueryspellchecker_driver : 'pspell',
                    // Editor CSS to display mispelled words highlighted
                    content_css :  WEBAPP_PATH + '/css/jquery.spellchecker.css'
                    // Spell checker configuration //
                });

            },
            controller:['$scope', function($scope) {
                this.scope = $scope;
            }]
        };
    }
    angular.module('app').directive('tinyMce', tinyMce);

}());